import React, { ForwardRefRenderFunction, useImperativeHandle, forwardRef, useState } from "react";

import { useTranslation } from "react-i18next";
import { TiWarningOutline } from "react-icons/ti";

import ConfirmationModal from "../../../../../../../../../components/Dialogs/ConfirmationModal";
import { Color } from "../../../../../../../../../components/Form/Button";
import { Carrier } from "../../../../../../../../../models/carrier";
import { Wrapper, Message, WarningMessage } from "./styled";

interface DeleteModalProps {
  onDelete: (carrier: Carrier) => void;
  isLoading: boolean;
}

export interface DeleteModalHandler {
  open: (carrier: Carrier) => void;
  close: () => void;
}

const DeleteModal: ForwardRefRenderFunction<DeleteModalHandler, DeleteModalProps> = (
  props,
  ref
) => {
  const { t: translate } = useTranslation();
  const { onDelete, isLoading = false } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [carrier, setCarrier] = useState<Carrier>();

  const onOpenModal = (data: Carrier) => {
    setCarrier(data);
    setOpen(true);
  };

  const onCloseModal = () => {
    setOpen(false);
    setCarrier(undefined);
  };

  useImperativeHandle(ref, () => ({
    open: onOpenModal,
    close: onCloseModal,
  }));

  return (
    <ConfirmationModal
      width="520px !important"
      open={open}
      closeModal={onCloseModal}
      type="error"
      title={translate("deleteCarrier")}
      leftIconTitle={<TiWarningOutline color="#F04438" size={20} />}
      customColorSave={Color.ERROR}
      customColorCancel={Color.TEXT_INFO}
      textSubmit={translate("delete")}
      submit={() => (carrier ? onDelete(carrier) : undefined)}
      loading={isLoading}
    >
      <Wrapper>
        <Message>
          {translate("areYouSureYouWantToDeleteThisCarrier")} {carrier?.scac}
        </Message>
        <WarningMessage>{translate("thisActionIsPermanentAndCannotBeUndone")}!</WarningMessage>
      </Wrapper>
    </ConfirmationModal>
  );
};

export default forwardRef(DeleteModal);
